export default "__VITE_ASSET__a0089357__"